import md5 from 'js-md5';

export default {
  getMd5(file, success, failure) {
    const hash = md5.create();
    const chunkSize = 2 * 1024 * 1024; // read size at once.
    let offset = 0; // read start position
    let blockRead = null;

    // function of reading separated file.
    const readContent = evt => {
      const result = new Uint8Array(evt.target.result);

      if (evt.target.error) {
        // on error
        failure(evt.target.error);
        return;
      }

      offset += result.length;
      hash.update(result);

      if (offset >= file.size) {
        // result
        success(hash.hex());
        return;
      } else {
        blockRead(offset);
      }
    };
    // reload
    blockRead = _offset => {
      const blob = file.slice(_offset, chunkSize + _offset);
      const fileReader = new FileReader();
      fileReader.onloadend = readContent;
      fileReader.readAsArrayBuffer(blob);
    };

    // start to read.
    blockRead(offset);
  },
};
